import { SIZE_SELECTED, SIZE_DESELECTED } from 'app/productDetails/productDetailsConstants';

export const sizeSelected = sizeItemSelected => ({
  type: SIZE_SELECTED,
  data: sizeItemSelected,
});

export const sizeDeselected = sizeItemDeselected => dispatch => {
  dispatch({
    type: SIZE_DESELECTED,
    data: sizeItemDeselected,
  });

  dispatch(sizeSelected(null));
};
